<div class="modal-header">
  <h4 class="modal-title">
    @if (neighborhood) {
      Editar conjunto {{ neighborhood.name }} 
    }

    @if (!neighborhood) {
      Nuevo conjunto
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (!loading) {
    <form
      id="formNeighborhood"
      [formGroup]="formNeighborhood"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          <!-- @if(imageBase64 || (neighborhood && neighborhood.image)) {
            <div class="col-12">
              <img [src]="imageBase64 ? imageBase64 : (neighborhood && neighborhood!.image) ? neighborhood.image.urlFile : ''" width="100%">
            </div>
          } -->

          @for (key of utilService.objectKeys(dataForm); track key) {
            @if (
              dataForm[key].type != "select" && 
              dataForm[key].type != "switch" &&
              dataForm[key].type != "textarea" &&
              dataForm[key].type != "image"
            ) {
              <!--
                RAMA PROPIA DEL CÓDIGO POSTAL.

                Antes este campo se resolvía con [attr.] y ternarios dentro del
                render genérico. Ya no alcanza: el botón "Buscar" tiene que ir
                DENTRO de un .input-group junto al input, y un envoltorio no se
                puede aplicar con un binding condicional. Envolver el input
                genérico para todos cambiaría el render de Nombre, Calle,
                Ciudad y Estado, que deben quedarse exactamente igual que hoy
                (.input-group es display:flex y le da al .form-control
                `width: 1%`, no es un div neutro).

                Darle rama propia tiene precedente en el proyecto: survey-modal
                ya abre una rama para 'datetime', y guard-modal y tag-modal
                usan moldes distintos del genérico. Además este HTML no lo
                comparte nadie —el markup está duplicado en los 27 modales, no
                es un template común—, así que la rama no afecta a ningún otro
                modal ni obliga a tocar DataFormModel, que consumen 28
                componentes.

                Efecto lateral bueno: la rama genérica de abajo vuelve a
                quedarse tal cual estaba antes de Copomex, sin ternarios.
              -->
              @if (key === zipCodeKey) {
                <div class="col-12 form-group mb-4">
                  <label [htmlFor]="key" class="form-label">
                    {{ dataForm[key].label }}
                  </label>

                  <!--
                    .input-group resuelve la adyacencia del campo y el botón.

                    ⚠️ EL .invalid-feedback VA DENTRO DEL GRUPO ⚠️
                    Bootstrap solo lo muestra con el selector HERMANO
                    `.is-invalid ~ .invalid-feedback`
                    (bootstrap.css:2909). Si el mensaje se quedara fuera del
                    .input-group dejaría de ser hermano del input y el mensaje
                    de campo obligatorio no se vería nunca.

                    .has-validation va con [class.] y no fijo: es la clase que
                    le dice a Bootstrap que el ÚLTIMO hijo del grupo es el
                    mensaje y no un control, para calcular los redondeos
                    (bootstrap.css:2777). Con el mensaje en pantalla, el input
                    es :nth-last-child(3) y pierde el redondeo derecho, y el
                    botón, que es :nth-last-child(2), lo conserva. Si la clase
                    fuera fija, al no renderizarse el mensaje el input
                    recuperaría su redondeo derecho y aparecería una costura
                    redondeada a media caja.
                  -->
                  <div
                    class="input-group"
                    [class.has-validation]="submitted && f[key].errors && dataForm[key].required">

                    <!--
                      maxlength e inputmode ya pueden ir como atributos fijos:
                      esta rama la usa un solo campo.
                      inputmode="numeric" levanta el teclado numérico en móvil
                      sin cambiar el type del control: sigue siendo text para no
                      perder el cero inicial de códigos como 01000.
                    -->
                    <input
                      [type]="dataForm[key].type"
                      class="form-control"
                      formControlName="{{ key }}"
                      [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                      aria-describedby="neighborhoodZipCodeStatus"
                      maxlength="5"
                      inputmode="numeric"
                      [ngClass]="{
                        'is-invalid': (submitted && f[key].errors) || zipCodeFormatWarned
                      }">

                    <!--
                      ⚠️ type="button" ES OBLIGATORIO ⚠️
                      Este botón vive dentro del <form (ngSubmit)="onSubmit()">
                      que envuelve el modal entero. Un <button> sin type es de
                      tipo submit por defecto: pulsar "Buscar" enviaría el
                      formulario e intentaría registrar el conjunto.

                      Solo se deshabilita mientras la consulta está en vuelo,
                      para evitar el doble disparo: ahí el motivo es evidente
                      porque el propio botón muestra el spinner. Con menos de 5
                      dígitos NO se deshabilita —mismo criterio que el botón
                      Registrar/Actualizar—: se pulsa y se pinta el error de
                      formato.

                      Va inmediatamente después del input en el DOM, así que
                      entra en el orden natural de tabulación justo detrás del
                      campo.
                    -->
                    <button
                      type="button"
                      class="btn btn-outline-primary d-inline-flex align-items-center"
                      [disabled]="searchingZipCode"
                      (click)="searchZipCode()">
                      @if (searchingZipCode) {
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          aria-hidden="true">
                        </span>
                      } @else {
                        <i class="material-icons me-2" aria-hidden="true">search</i>
                      }
                      Buscar
                    </button>

                    @if (submitted && f[key].errors && dataForm[key].required) {
                      <div class="invalid-feedback">
                        @if (f[key].errors!['required']) {
                          <div>{{ dataForm[key].requiredMessage }}</div>
                        }
                      </div>
                    }
                  </div>

                  <!--
                    El contenedor se renderiza SIEMPRE, con la altura de una
                    línea ya reservada en el .scss: el spinner y los mensajes
                    aparecen y desaparecen sin empujar hacia abajo los campos
                    que siguen ni los botones del modal.
                  -->
                  <div
                    id="neighborhoodZipCodeStatus"
                    class="zip-code-status">

                    <!--
                      Error de FORMATO del código postal.

                      Vive aquí y no en el .invalid-feedback de arriba porque
                      ese bloque solo sabe pintar dataForm[key].requiredMessage.
                      Sin este mensaje, teclear 123 y pulsar Registrar pintaría
                      el input de rojo sin una sola palabra que explicara por
                      qué.

                      El texto es EL MISMO que usa la página de Dirección para
                      esta regla: dos redacciones distintas para la misma
                      validación se leen como dos reglas distintas.

                      La condición se resolvió en el .ts
                      (zipCodeFormatErrorVisible) porque ya son tres reglas:
                      el intento de registro, el clic en Buscar y las dos
                      exclusiones que garantizan un solo mensaje a la vez.
                    -->
                    @if (zipCodeFormatErrorVisible) {
                      <small class="text-danger" role="alert">
                        El código postal debe tener exactamente 5 dígitos
                      </small>
                    }

                    @if (searchingZipCode) {
                      <span class="text-secondary d-inline-flex align-items-center" role="status">
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          aria-hidden="true">
                        </span>
                        <small>Buscando…</small>
                      </span>
                    }

                    @if (zipCodeNotFound) {
                      <small class="text-danger" role="alert">
                        No encontramos ese código postal.
                      </small>
                    }

                    @if (zipCodeSearchFailed) {
                      <small class="text-danger" role="alert">
                        No pudimos consultar el código postal.
                      </small>
                    }

                  </div>
                </div>
              } @else {
                <!--
                  Render genérico de los campos de texto (nombre, calle, ciudad,
                  estado y los numéricos). Es el mismo molde que usan los demás
                  modales del proyecto: sin ternarios y sin nada de Copomex.
                -->
                <div class="col-12 form-group mb-4">
                  <label [htmlFor]="key" class="form-label">
                    {{ dataForm[key].label }}
                  </label>
                  <input
                    [type]="dataForm[key].type"
                    class="form-control"
                    formControlName="{{ key }}"
                    [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                    [ngClass]="{
                      'is-invalid': submitted && f[key].errors
                    }">
                    @if (submitted && f[key].errors && dataForm[key].required) {
                      <div class="invalid-feedback">
                        @if (f[key].errors!['required']) {
                          <div>{{ dataForm[key].requiredMessage }}</div>
                        }
                      </div>
                    }
                </div>
              }
            }

            @if (dataForm[key].type === 'select') {
              <div class="mb-4">
                <div class="mb-1">
                  {{ dataForm[key].label }}
                </div>
                <ng-select
                  [items]="dataForm[key].data!"
                  [bindLabel]="dataForm[key].labelSelect!"
                  [bindValue]="dataForm[key].idSelect!"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? ''">
  
                </ng-select>
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="text-danger">
                    @if (f[key].errors!['required']) {
                      {{ dataForm[key].requiredMessage }}
                    }
                  </div>
                }
              </div>
            }

            @if (dataForm[key].type === 'switch') {
              <div class="col-12 mt-2 mb-4">
                <div class="row">
                  <div class="col-8">
                    {{ dataForm[key].label }}
                  </div>
                  <div class="col-4 text-end">
                    <p-inputSwitch
                      formControlName="{{ key }}">

                    </p-inputSwitch>
                  </div>
                </div>
              </div>
            }

            @if (dataForm[key].type === 'textarea') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <textarea
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }"></textarea>
                  @if (submitted && f[key].errors && dataForm[key].required) {
                    <div class="invalid-feedback">
                      @if (f[key].errors!['required']) {
                        <div>{{ dataForm[key].requiredMessage }}</div>
                      }
                    </div>
                  }
              </div>
            }

            @if(dataForm[key].type == 'image') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input 
                  class="form-control" 
                  type="file" 
                  [id]="key"
                  (change)="onFileChange($event)">
              </div>
            }

          }

        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formNeighborhood"
      class="btn btn-primary w-100">
      {{ neighborhood ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>